<script setup lang="ts">
import { useEventListener } from "@vueuse/core"
import { uniqueId } from "lodash-es"
import { onBeforeMount, onMounted } from "vue"
import ComboBoxV2 from "./ComboBoxV2.vue"
import createGraphQLSource from "./sources/createGraphQLSource"
import { type ComboBoxStore, useComboBoxStore } from "./store"

const props = defineProps<{
  name: string
  titles: string[]
  hint: string
}>()

const combobox = useTemplateRef<HTMLElement>("combobox")

const store: ComboBoxStore = useComboBoxStore(uniqueId("similarTitleStore"))
const { source, selections, field } = storeToRefs(store)

onBeforeMount(async () => {
  source.value = await createGraphQLSource("PdlAutocompleteQuery")
  field.value = "title"
})

onMounted(() => {
  if (combobox?.value !== null) {
    const form = (combobox.value as HTMLElement).closest("form")
    useEventListener(form, "reset", () => {
      selections.value = []
    })
  }
})

selections.value = props.titles.map((title) => store.textToResult(title))

watch(selections, () => {
  combobox.value?.dispatchEvent(new Event("change"))
})
</script>

<template>
  <div ref="combobox">
    <ComboBoxV2
      :name="name"
      :store="store"
      :readonly="false"
      :hint="hint"
      placeholder="Search titles"
    />
  </div>
</template>
